import { Button, Checkbox, Col, Form, Modal, notification, Row } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { viewersApi } from 'api/viewUserApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectIsDisable } from 'features/Login/authSlice';
import {
  selectStatusAdd,
  selectViewersError,
  ViewersActions,
} from 'features/User/components/Viewers/ViewerSlide';
import { paramOption, plantInfo } from 'models';
import { ViewerInfo } from 'models/viewers';
import * as React from 'react';
import { selectSidebarList } from '../Sidebar/sidebarSlice';
export interface AddFormPlantOfViewerProps {
  itemViewer: ViewerInfo;
  viewerPlant: plantInfo[];
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  setPlantList: (array: plantInfo[]) => void;
}

export default function AddFormPlantOfViewer({
  itemViewer,
  viewerPlant,
  isModalVisible,
  setPlantList,
  setIsModalVisible,
}: AddFormPlantOfViewerProps) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const plantList = useAppSelector(selectSidebarList);
  const [valueCheckBox, setValueCheckBox] = React.useState<CheckboxValueType[]>([]);
  const statusAdd = useAppSelector(selectStatusAdd);
  const error = useAppSelector(selectViewersError);
  const isDisable = useAppSelector(selectIsDisable);

  React.useEffect(() => {
    if (statusAdd) {
      if (error) {
        openNotificationWithIcon('error', error);
      } else {
        openNotificationWithIcon('success', 'Add plants to viewer successfully!');
        dispatch(ViewersActions.resetViewerSlice());
      }
      (async () => {
        const res = await viewersApi.getPlantsByViewerId(itemViewer.id);
        setPlantList(res);
      })();
    }
  }, [statusAdd, error, itemViewer, setPlantList, dispatch]);

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const setOptionList = (array: plantInfo[]) => {
    let newArray: paramOption[] = [];
    array.map((item) => {
      let newItem = {
        label: `${item.code}-${item.label}`,
        value: item.id,
      };
      return (newArray = [...newArray, newItem]);
    });
    return newArray;
  };

  const setOptionListTwo = (arrayOne: plantInfo[], arrayTwo: plantInfo[]) => {
    let newArray = arrayTwo;
    arrayOne.map((item) => {
      return (newArray = newArray.filter((x) => x.id !== item.id));
    });
    return newArray;
  };

  const onChangeCheckBox = (checkedValues: CheckboxValueType[]) => {
    setValueCheckBox(checkedValues);
  };

  const handleOk = async () => {
    await dispatch(ViewersActions.addPlantsToViewer({ array: valueCheckBox, id: itemViewer.id }));
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <Modal
      visible={isModalVisible}
      title={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
          }}
        >
          Plant List
        </div>
      }
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            height: '50px',
          }}
        >
          <Button onClick={handleCancel} size="large">
            Cancel
          </Button>
          <Button disabled={isDisable} onClick={() => form.submit()} size="large">
            Submit
          </Button>
        </div>
      }
      width={720}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        // layout="vertical"
        onFinish={() => handleOk()}
        labelCol={{
          span: 2,
        }}
        wrapperCol={{
          span: 22,
        }}
      >
        <Form.Item name="jobs" label="Plant :">
          <div
            style={{
              width: '100%',
              height: '200px',
              overflowY: 'auto',
              overflowX: 'clip',
              border: '1px solid #DEDEDE',
            }}
          >
            <Checkbox.Group
              style={{
                paddingTop: '8px',
                paddingLeft: '10px',
              }}
              onChange={onChangeCheckBox}
            >
              <Row>
                {viewerPlant.length === 0
                  ? setOptionList(plantList).map((x, index) => (
                      <Col span={24}>
                        <Checkbox key={index} value={x.value}>
                          {x.label}
                        </Checkbox>
                      </Col>
                    ))
                  : setOptionList(setOptionListTwo(viewerPlant, plantList)).map((x, index) => (
                      <Col span={24}>
                        <Checkbox key={index} value={x.value}>
                          {x.label}
                        </Checkbox>
                      </Col>
                    ))}
              </Row>
            </Checkbox.Group>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}
